import { Box } from "@mui/material";
import ReactLoading from "react-loading";

const LoadingBtn = ({ height, isSmall }) => {
  return (
    <Box
      sx={{
        height: height || "38px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#405189",
        borderRadius: "3px",
        width: "100%",
      }}
    >
      <ReactLoading
        type="cylon"
        color="#fff"
        height={isSmall ? "44px" : "55px"}
        width={isSmall ? "45px" : "56px"}
      />
    </Box>
  );
};

export default LoadingBtn;
